import { wp } from '@/lib/api'

import page from '@/models/page'
import post from '@/models/post'
import attachment from '@/models/attachment'
import taxonomy from '@/models/taxonomy'

import cpt, { type RawCpt, type CptModel } from '@/models/cpt'

async function fetchCpt(restBase: string): Promise<CptModel[]> {
  return fetchList<RawCpt, CptModel>(restBase, cpt)
}

// Model types (based on the existing mapper functions)
type PageModel = ReturnType<typeof page>
type PostModel = ReturnType<typeof post>
type AttachmentModel = ReturnType<typeof attachment>
type TaxonomyModel = ReturnType<typeof taxonomy>

async function fetchList<Raw, Model>(path: string, map: (raw: Raw) => Model): Promise<Model[]> {
  const { data } = await wp.get<Raw[]>(path)
  return data.map(map)
}

export const ContentService = {
  // regular content
  pages: (): Promise<PageModel[]> => fetchList('pages', page),
  posts: (): Promise<PostModel[]> => fetchList('posts', post),
  attachments: (): Promise<AttachmentModel[]> => fetchList('media', attachment),

  references() {
    return fetchCpt('references')
  },
  faq() {
    return fetchCpt('faq')
  },

  // taxonomies (multiple endpoints, flattened together)
  async taxonomies(): Promise<TaxonomyModel[]> {
    const endpoints = [
      // 'term_faq',
    ]

    const results = await Promise.all(endpoints.map((p) => wp.get(p)))
    return results.flatMap((r) => r.data.map(taxonomy))
  },
}
